module.exports = __webpack_public_path__ + "img/clues.7407d532.jpg";